module.exports = __webpack_public_path__ + "img/crane-truck-icon.f351497e.svg";